import apiTrainers from '@/api/trainers'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  trainerIsBlockedStart: '[trainer is blocked] trainer is blocked start',
  trainerIsBlockedSuccess: '[trainer is blocked] trainer is blocked  success',
  trainerIsBlockedFailure: '[trainer is blocked] trainer is blocked  failure',
}

export const actionTypes = {
  trainerIsBlocked: '[trainer is blocked] trainer is blocked',
}

const mutations = {
  [mutationTypes.trainerIsBlockedStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.trainerIsBlockedSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.trainerIsBlockedFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.trainerIsBlocked](context, data) {
    context.commit(mutationTypes.trainerIsBlockedStart)
    return new Promise((resolve) => {
      apiTrainers
        .trainerIsBlocked(data)
        .then((response) => {
          context.commit(mutationTypes.trainerIsBlockedSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.trainerIsBlockedFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
